// extracted by css-extract-rspack-plugin
export default {"root":"_dmwm_","heading":"GfdoIs","list":"MeCJJc"};